import takeoverPanel from './takeover-panel'
export default takeoverPanel
